// shared form handling for modal and standalone registration pages

import './form.sass';

export function setupRegistrationForm() {
  const $gender = $('#id_gender');
  const $genderDiv = $('.form-field.gender');
  const $describedDiv = $('#described_gender');
  const $closeDescribed = $('#close_described');
  const $countrySelect = $('#id_country');
  const $marketingCheckbox = $('#id_email_newsletter');

  function onChangeGender() {
    const value = $gender.val();
    if (value === 'O') {
      // make sure the self-describe box is shown
      $genderDiv.hide();
      $describedDiv.show();
    } else {
      $describedDiv.hide();
      $genderDiv.show();
    }
    $describedDiv.removeClass('hidden');
  }

  $gender.on('change', onChangeGender);
  onChangeGender();

  function onChangeCountry() {
    const country = $countrySelect.val();
    if (country === 'US') {
      $marketingCheckbox.prop('checked', true);
    } else {
      $marketingCheckbox.prop('checked', false);
    }
  }

  $countrySelect.on('change', onChangeCountry);

  $closeDescribed.click((e) => {
    e.preventDefault();
    $gender.val('');
    onChangeGender();
    return false;
  });
}
